import { connect } from 'react-redux'
import { setModal } from '@hixme/modal'

import { selectors as userSessionSelectors } from 'store/modules/user-session'
import * as personSelectors from 'store/modules/persons/selectors'
import { HELP } from 'modal-constants'

import Header from 'components/Header'

const mapStateToProps = (state) => {
  const person = personSelectors.getPersonSelector(state)
  const companyName = userSessionSelectors.getCompanyName(state)
  const logoUrl = userSessionSelectors.getCompanyLogoUrlSelector(state)
  const enrollmentResponses = userSessionSelectors.getEnrollmentResponses(state)
  const enrollmentComplete = userSessionSelectors.getEnrollmentCompleteSelector(state)
  const isCartCommitted = userSessionSelectors.isCartCommitted(state)
  const enrollmentInfo = userSessionSelectors.getEnrollmentInfoSelector(state)
  const isGuestUser = userSessionSelectors.isGuestUser(state)
  const isCreatingOrUpdating = userSessionSelectors.isCreatingOrUpdating(state)

  const hideCartSummary =
    !person.VerifiedPersonalInfo ||
    !enrollmentInfo.isEnrolling ||
    enrollmentComplete ||
    isCartCommitted
  return {
    logoUrl,
    enrollmentComplete,
    enrollmentResponses,
    person,
    companyName,
    hideCartSummary,
    isGuestUser,
    isCreatingOrUpdating,
  }
}

export default connect(
  mapStateToProps,
  (dispatch) => ({
    showHelpModal: () => {
      dispatch(setModal(HELP))
    },
  })
)(Header)
